import UserHistory from './UserHistory';

export default UserHistory;
